import { render, staticRenderFns } from "./AdsManagementAdd.vue?vue&type=template&id=2aaf72df&"
import script from "./AdsManagementAdd.vue?vue&type=script&lang=js&"
export * from "./AdsManagementAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports